import dispatcher from '../dispatcher';

const html = document.documentElement;
let prevented = html.classList.contains('popupActive');
let lastOpened: PopupViewElement | null = null;
let offset = 0;


const disableScroll = () => {
  if (!prevented) {
    const vw = html.clientWidth;

    html.classList.add('popupOpened');

    offset = html.clientWidth - vw;

    html.style.marginRight = offset + 'px';
    prevented = true;
  }
}
const enableScroll = () => {
  if (prevented) {
    html.classList.remove('popupOpened');
    html.style.marginRight = '';
    prevented = false;
  }

  offset = 0;
}


export class PopupViewElement extends HTMLElement {
  private _isActive: boolean;
  private readonly _inner: HTMLDivElement;

  private readonly onDocEsc: (e: KeyboardEvent) => void;

  constructor() {
    super();

    this._isActive = this.classList.contains('active');

    this._inner = this.querySelector<HTMLDivElement>('.popupInner')!;

    const closeButtons = Array.from(this.querySelectorAll('.popupSelfClose'));
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => this.close());
    });

    this.onDocEsc = (e) => this._isActive && e.key === 'Escape' && this.close();
  }

  connectedCallback() {
    document.documentElement.addEventListener('keydown', this.onDocEsc);
  }
  disconnectedCallback() {
    document.documentElement.removeEventListener('keydown', this.onDocEsc);

    if (lastOpened === this) {
      lastOpened = null;
      enableScroll();
    }
  }

  public open() {
    this.classList.remove('hidden');
    if (lastOpened) {
      lastOpened.close();
    } else {
      disableScroll();
    }

    this._inner.style.paddingRight = offset + 'px';

    this.classList.add('active');

    dispatcher.dispatch({
      type: 'menu-close'
    })

    lastOpened = this;
    this._isActive = true;
  }
  public close(isReOpen: boolean = false) {
    this.classList.remove('active');

    if (!isReOpen) {
      enableScroll();

      this._inner.style.paddingRight = '';
    }

    setTimeout(() => {
      this.classList.add('hidden');
    }, 500)

    lastOpened = null;
    this._isActive = false;
  }
}

window.customElements.define('popup-view', PopupViewElement);
